module.exports = __webpack_public_path__ + "img/united_kingdom.1e55817a.jpg";